import React, { Component } from 'react';
import PropTypes from 'prop-types';

export function viewLogic(props) {
    return {
        ...props,
        isButtonDisabled: props.isButtonDisabled || !props.isStartedToSetPassword,
    };
}

export function stateLogic(component) {
    class RequestForgottenPasswordStateLogic extends Component {
        static propTypes = {
            userConfig: PropTypes.shape({
                value: PropTypes.string.isRequired,
                onChange: PropTypes.func.isRequired,
            }).isRequired,
        };

        get isStartedToSetPassword() {
            return !!(this.props.userConfig.value.length);
        }

        render() {
            return React.createElement(component, {
                ...this.props,
                isStartedToSetPassword: this.isStartedToSetPassword,
            });
        }
    }

    return RequestForgottenPasswordStateLogic;
}
